import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { registerOnSaveSharedTabUserListEffect } from '@/store/sharedWorkspace/updateSharedUserList.workflow.ts';
import { registerShareTabListener } from '@/store/sharedWorkspace/workflows/saveSharedTab.workflow.ts';
import { registerStopSharingTabListener } from '@/store/workspace/stopSharingTab.workflow.ts';

export function registerSharedWorkspaceListeners(startAppListening: StartAppListening) {
  registerOnSaveSharedTabUserListEffect(startAppListening);
  registerShareTabListener(startAppListening);
  registerStopSharingTabListener(startAppListening);
}
